<template>
  <div id="map-box">
    <Toolfliter v-if="!isDetail" @selectTime="selectTime" class="toolFliter" />
    <div id="projectprogress" v-loading="loading" :style="{ 'height': isDetail ? '344px' : '284px' }"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
import Toolfliter from './toolFliter'
import api from '@/services/api/statistics/statistics'
import dayjs from "dayjs";
export default {
  props: {
    projectId: {
      type: [Number, String],
      default: 0
    },
    rangeTime: {
      type: [Array, Object],
      default() {
        return []
      }
    },
    // 是否为详情页面引用的组件
    isDetail: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Toolfliter
  },
  data() {
    return {
      loading: true,
      opation: {
        legend: {
          textStyle: { fontSize: 12, color: "rgba(32, 32, 32, .6)" },
          icon: 'circle',
          itemWidth: 8,
          left: 76,
          bottom: 0,
          itemGap: 26
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          extraCssText: 'box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);',
          padding: 16,
          textStyle: {
            color: 'initial'
          },
          formatter: (value) => {
            return this.getTipItem(value)
          }
        },
        color: ['#02B97E', '#FFC758', '#73B2FF', '#FF9393', '#D8D8D8'],
        dataset: {
          source: [
            ['product', '任务总数', '未完成', '已完成', '待认领', '已归档'],
            // ['产品项目部', 41.1, 30.4, 125.1],
            // ['技术部', 86.5, 92.1, 155.7],
            // ['质量管理部', 24.1, 67.2, 300.5],
            // ['市场部', 24.1, 67.2, 79.5],
            // ['销售部', 24.1, 67.2, 79.5]
          ]
        },
        xAxis: {
          type: 'category',
          splitLine: {
            // show: true
          },
          axisLine: {
            lineStyle: {
              color: "rgba(32, 32, 32, .6)"
            }
          },
          axisTick: {
            lineStyle: {
              color: 'rgba(32, 32, 32, 0.08)'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            lineStyle: {
              color: 'rgba(32, 32, 32, 0.08)'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgba(32, 32, 32, .6)"
            }
          }
        },
        grid: {
          containLabel: true,
          top: 34,
          left: 0,
          right: 0,
          bottom: 45
        },
        series: [
          { type: 'line', barMaxWidth: 28, },
          { type: 'line', barMaxWidth: 28, },
          { type: 'line', barMaxWidth: 28, },
          { type: 'line', barMaxWidth: 28, },
          { type: 'line', barMaxWidth: 28, },
        ]
      },
      weeks: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
      start_time: '',
      end_time: ''
    }
  },
  watch: {
    projectId(val) {
      if (val) {
        this.init()
        this.getTableData()
      }
    },
    rangeTime: {
      handler() {
        this.getTableData()
      },
      deep: true
    },
  },
  mounted() {
    this.init()
    if (this.isDetail && this.rangeTime.length) {
      this.getTableData()
    }
  },
  methods: {
    init() {
      if (this.isDetail) {
        // 详情页面引用，需要对echarts的参数进行修改
        this.opation.legend.left = 'center'
        this.opation.legend.top = 48

        this.opation.grid = {
          top: 92,
          left: 74,
          right: 74,
          bottom: 82
        }
      }
      var myChart = echarts.init(document.getElementById('projectprogress'));
      myChart.clear()
      myChart.setOption(this.opation)

      myChart.on('click', 'series', () => {
        this.$emit('mapClick')
      })
    },
    selectTime(val) {
      this.loading = true
      this.start_time = dayjs(val[0].getTime()).format("YYYY-MM-DD")
      this.end_time = dayjs(val[1].getTime()).format("YYYY-MM-DD")
      this.getTableData()
    },
    getTableData() {
      let params = {
        project_id: this.projectId,
        start_time: this.start_time,
        end_time: this.end_time,
        number: 999,
        page: 1
      }
      if (this.isDetail) {
        params.start_time = this.rangeTime[0]
        params.end_time = this.rangeTime[1]
      }
      api.projectProgressOverview(params).then(res => {
        let arr = []
        res.data.forEach(item => {
          let days = item.day.split('-')
          let monthday = `${days[1]}/${days[2]}`
          arr.push([monthday, item.total_number_of_tasks, item.undone_number_of_tasks, item.completed_number_of_tasks, item.pending_number_of_tasks, item.archived_number_of_tasks, days[0]])
        })
        this.loading = false
        this.opation.dataset.source = [['product', '任务总数', '未完成', '已完成', '待认领', '已归档'], ...arr]
        this.init()
      })
    },
    getTipItem(value) {
      let date = value[0].data[value[0].data.length - 1] + '/' + value[0].data[0]
      let week = this.weeks[new Date(date).getDay()]
      let str = `<div class="tool-title">${week} ${date}</div>`
      value.forEach((res, index) => {
        let data = `
          <div class="tool-title-item">
            <p class="tool-title-item---left">
              <span style="background:${res.color};"></span>
              <span>${res.seriesName}</span>
            </p>
            <p class="tool-title-item---right">${res.data[index + 1]}</p>
          </div>
        `
        str = str + data
      })
      return str
    }
  }
}
</script>

<style lang="scss" scoped>
#projectprogress {
  width: 100%;
  height: 100%;
}
#map-box {
  width: 100%;
  height: 100%;
}
::v-deep {
  .tool-title-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: rgba(32, 32, 32, 0.4);
    margin-top: 6px;
    .tool-title-item---left {
      display: flex;
      align-items: center;
      span:first-child {
        margin-right: 8px;
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
      }
    }
    .tool-title-item---right {
      color: rgba(25, 24, 67, 0.8);
    }
  }
}
</style>
